/**
 * newPasswordCreat.jsx
 * new password form used when creating a new password
 */
import axios from "axios";
import React, {useState} from "react";
import '../../style/forgotPass.css';
import { useParams } from "react-router-dom";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import ErrorMessage from "../Misc/ErrorMessage";
import SuccMessage from "../Misc/succMessage";

function NewPasswordCreate () {
    const [newPass, setNewPass] = useState("");
    const [confirmPass, setConfirmPass] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [succMessage, setSuccMessage] = useState("");

    const {user} = useParams();
    /**
     * function newPassword()
     * takes in passwords enter by user to set as new password for that user
     */ 
    async function newPassword() {
        

        const passData = {
            id: user,
            newPass: newPass,
            confirmPass: confirmPass
        };

        try {
            const response = await axios.put('https://link2rsvp.herokuapp.com/auth/newpass', passData);
            console.log(response.data.succMessage);
            setSuccMessage(response.data.succMessage);
        } catch (err) {
            if(err.response) {
                if(err.response.data.errorMessage) {
                    setErrorMessage(err.response.data.errorMessage);
                }
            }
        }
    }

    return (
        <div>
            <div id="head">
                <h1 id="headp">LINK2RSVP</h1>
            </div>

            {
                errorMessage && (
                    <ErrorMessage
                    message={errorMessage}
                    clear={() => setErrorMessage(null)}
                    />
                )
            }

            {
                succMessage && (
                    <SuccMessage
                    message={succMessage}
                    clear={() => setSuccMessage(null)}
                    />
                )
            }

            <div id="forgotPass">
                <h3 id="forgot">Create your new password</h3>
                <form>
                    <Form.Group className="mb-3">
                        <Form.Label htmlFor="newPass">Please enter your new password</Form.Label>
                        <Form.Control
                        id="newPass"
                        type="password"
                        name="password"
                        placeholder="Enter New Password"
                        onChange={(e) => setNewPass(e.target.value)}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label htmlFor="confirmPass">Please confrim your new password</Form.Label>
                        <Form.Control
                        id="confirmPass"
                        type="password"
                        name="ConfrimNewPass"
                        placeholder="Confirm New Password"
                        onChange={(e) => setConfirmPass(e.target.value)}
                        />
                    </Form.Group>

                    <Button
                    id="passReset"
                    varaint="primary"
                    onClick={newPassword}
                    >
                        Submit
                    </Button>
                </form>
            </div>
        </div>
    );
}

export default NewPasswordCreate;